module.exports = __webpack_public_path__ + "static/img/header_logo.d398788.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/header_logo.png
// module id = 9C+W
// module chunks = 1